// 导出Excel公用方法
import { EXPORT_API } from "./commonVariable";
import throttle from 'lodash/throttle';
import axios from 'axios'
// 创建实例
const ser = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 50000 // 超时时间
})


export function exportMethod(data) {
  // ser({
  //   method: data.method,
  //   url: `${data.url}${data.params ? '?' + data.params : ''}`,
  //   responseType: 'blob'
  // }).then((res) => {
  //   const link = document.createElement('a')
  //   let blob = new Blob([res.data])
  //   link.style.display = 'none';
  //   link.href = URL.createObjectURL(blob);

  //   // link.download = res.headers['content-disposition'] //下载后文件名
  //   link.download = data.fileName; //下载的文件名
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link)
  // }).catch(error => {
  //   console.log(error)
  // })
  window.location.href = process.env.VUE_APP_UPLOAD_BASE_API + data.url + '?' + data.params
}

export function exportMethod2(data) {
  const token = localStorage.getItem('Authorization');
  if (EXPORT_API.indexOf('gbms.gree.com') !== -1) {
    // https访问时下载不了文件
    window.location.href = `apis/${data.url}?${data.params}&token=${encodeURIComponent(token)}`
  } else {
    window.location.href = `${EXPORT_API}${data.url}?${data.params}&token=${encodeURIComponent(token)}`
  }



  //https访问时下载不了文件
  // const token = localStorage.getItem('Authorization');
  // window.location.href = `apis/${data.url}?${data.params}&token=${encodeURIComponent(token)}`

  // window.location.href = EXPORT_API + data.url + '?' + data.params

  // const token = localStorage.getItem('Authorization');
  // const url = EXPORT_API + data.url;
  // const params = data.params;
  // const fullUrl = `${url}?${params}&token=${encodeURIComponent(token)}`;
  // window.location.href = fullUrl;
}

// export const exportMethod2 = throttle(_exportMethod2, 1000);
